import { DatePicker, Modal, Pagination, Tooltip, Drawer, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
//import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ADMIN_USER,
  USER_DATA,
  USER_TYPE,
  DOCTOR,
  INTERBRANCH_COORDINATOR,
  PATIENT,
  CLINIC_ADMIN,
} from "../../constants/const";
//import { DatePicker, Space } from "antd";
import "./todaysreport.css";
// import { FETCH_MIS_REPORT, GET_DASHBOARD_MORE } from '../../Redux/Slice/DetailedReportSlice';
import {
  INTERBRANCH_MODAL,
  INTERBRANCH_ADMIN_DASHBOARD_SELECTED,
} from "../../actions/type";
import {
  FETCH_ADMIN_DASHBOARD_REPORT,
  FETCH_DASHBOARD_MORE,
  FETCH_ADMIN_DETAILED_REPORT,
  downloadAppointmentReport,
} from "../../actions/InterbranchAdminActions";
import { getFromLocalStorage } from "../../Helpers/localStorageHelper";
import {
  separaetdateAndTime,
  convertDateToString,
} from "../../Helpers/dateFunctions";
//import { convertDateToString } from '../../Helpers/dateFunctions';
import EmptyTableData from "../Common/EmptyTableData/EmptyTableData";
import TodaysReportModalContent from "../TodaysReportModalContent/TodaysReportModalContent";
import { fetch_doctors_list } from "../../actions/ClinicAdminAction";
import Spinner from "react-bootstrap/Spinner";
import ResetFilterButton from "../InterbranchAdminComponents/ResetFilterButton/ResetFilterButton";
import { CloseCircleOutlined, DownOutlined } from "@ant-design/icons";
import StatusBadge from "../Badges/StatusBadge/StatusBadge";
import { getConsultationStatusFlag } from "../../Helpers/ClinicAdminHelper";
import AdminAppointmentFilters from "../AdminAppointmentFilters/AdminAppointmentFilters";
import { fetchgangaSpeciality, fetchallSpeciality } from "../../actions/SpecialityListingAction";

const { RangePicker } = DatePicker;

function TodaysReport() {
  const dispatch = useDispatch();
  const dateRef = useRef(null);

  let [isModelOpen, setModelOpen] = useState(false);
  let [activePage, setActivePage] = useState(1);
  let [isOpen, setOpen] = useState(false);
  let [pagination, setPagination] = useState(0);
  const [userType, setUserType] = useState();
  const [clinicId, setclinicId] = useState();
  const [dashboardData, setDashboardData] = useState([]);
  const [paramdata, setparamdata] = useState({});
  let [loader, setLoader] = useState(true);
  let [isInitial, setinitial] = useState(true);
  let [isChnaged, setisChnaged] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  let [selectedDate, setSelectedDate] = useState({ from: null, to: null });
  const [doctorList, setDoctorList] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [operation, setOperation] = useState("start");
  const [resetfilter, setresetfilter] = useState(false);
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(null);
  const [selectedAppointmentStatus, setSelectedAppointmentStatus] =
    useState(null);
  const [filterParams, setFilterParams] = useState(null);
  const [appointmentStatus, setAppointmentStatus] = useState(null);
  const [patientName, setPatientName] = useState(null);
  const [appointmentDateSearch, setAppointmentDateSearch] = useState(null);
  const [doctorSearch, setDoctorSearch] = useState(null);
  const [selectedDoctorName, setSelectedDoctorName] = useState(null);
  const [downloaable, setDownloaable] = useState(false);
  const [patientNumber, setPatientNumber] = useState(null);
  const [patientEmail, setPatientEmail] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filtersReset, setFiltersReset] = useState(false);
  const [department, setDepartment] = useState(null);
const [specialityvalue, setSpecialityvalue] = useState(null);
  let selectedAppointment = useSelector(
    (state) => state.interbranchAdmin.dashboardSelected
  );
  console.log("selectedAppointment", selectedAppointment);
  let requestID = localStorage.getItem("apptid");

  let userData = localStorage.getItem("userData");
  useEffect(() => {
    if (JSON.parse(userData).userType === CLINIC_ADMIN) {
      setclinicId(JSON.parse(userData).clinicId);
    }
    checUser();
  }, []);

  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserType(JSON.parse(res).userType);
    });
  };

  const [departments, setDepartments] = useState([]);
  
  const [speciality, setSpeciality] = useState([]);

  useEffect(() => {
  const fetchData = async () => {
    const orthoRes = await dispatch(fetchgangaSpeciality("Others"));
 
    let allOptions = [];

    if (orthoRes) {
      const orthoOptions = orthoRes.map(item => ({
        id: item.specialityId,
        name: item.subspecialityName,
      }));
      allOptions = [...allOptions, ...orthoOptions];
    }


    setDepartments(allOptions);
  };

  fetchData();
}, [dispatch]);
 useEffect(() => {
  const fetchspecialityData = async () => {
    const orthoRes = await dispatch(fetchallSpeciality("all"));
 
    let allOptions = [];
    console.log("orthoRes",orthoRes )

    if (orthoRes) {
      const orthoOptions = orthoRes.map(item => ({
       id: item.SpecialityId,
					name: item.specialityName,
      }));
      
      setSpeciality(orthoOptions);
    }


    
  };

  fetchspecialityData();
}, [dispatch]);

  console.log('departmentsss', departments)

  const handleDownloadRequest = (dateRange) => {
    setIsDownloading(true);
    if (dateRange.name === "TODAY") {
      downloadReport(null, null);
    } else {
      const { fromDate, toDate } = dateRange;
      downloadReport(fromDate, toDate);
    }
  };

  let formattedMobileNumber = null;
  if (patientNumber) {
    const { dialCode, number } = patientNumber;
    formattedMobileNumber = `%2B${dialCode} ${number}`;
    console.log("mobileNumber", formattedMobileNumber);
  }

  let downloadReport = (fromDate, toDate) => {
    console.log("Downloading report.........");
    const today = new Date();
    const todayString = convertDateToString(today);

    dispatch(
      downloadAppointmentReport({
        fromDate: selectedDate.from,
        toDate: selectedDate.to,
        doctorId: doctorSearch,
        operation: operation,
        appointmentDate: appointmentDateSearch,
        appointmentStatus: appointmentStatus,
        patientName: patientName,
        patientNumber: formattedMobileNumber,
        patientEmail: patientEmail,
        department: department,
        speciality:specialityvalue,

        clinicId:
          JSON.parse(userData).userType === CLINIC_ADMIN
            ? JSON.parse(userData).clinicId
            : "",
        operationDate: convertDateToString(new Date()),
        startDate: selectedDate.from,
        endDate: selectedDate.to,
      })
    ).then((res) => {
      console.log("Response:", res);
      if (res) {
        console.log("Download URL:", res);
        window.open(res, "_blank");
        setIsDownloading(false);
      }
    });
  };

  const handleDoctorSelect = (doctorId) => {
    setSelectedDoctorId(doctorId);
  };

  const handleAppointmentDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");
    setSelectedAppointmentDate(formattedDate);
  };

  console.log("selectedAppointmentDate", selectedAppointmentDate);

  const handleAppointmentStatusChange = (status) => {
    setSelectedAppointmentStatus(status);
  };
  console.log("filterParams", filterParams);

  const selectedDoctor = doctorList.find(
    (doctor) => doctor.doctorName === filterParams?.value
  );

  const handleFilterAndSearch = (filterParams) => {
    if (!filterParams) {
      // Reset all filter-related states
      setAppointmentStatus(null);
      setPatientName(null);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setPatientNumber(null);
      setPatientEmail(null);
      setDepartment(null);
      return;
    }
    if (filterParams && filterParams.name === "BY_STATUS") {
      setAppointmentStatus(filtersReset ? null : filterParams.value);
      setAppointmentDateSearch(null);
      setPatientName(null);
      setDoctorSearch(null);
      setPatientNumber(null);
      setPatientEmail(null);
      setDepartment(null);
    } else if (filterParams && filterParams.name === "BY_PATIENT") {
      setPatientName(filtersReset ? null : filterParams.value);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setAppointmentStatus(null);
      setPatientNumber(null);
      setPatientEmail(null);
      setDepartment(null);
    } else if (filterParams && filterParams.name === "BY_DATE") {
      console.log("filter", filterParams.value);
      setAppointmentDateSearch(filtersReset ? null : filterParams.value);
      setAppointmentStatus(null);
      setDoctorSearch(null);
      setPatientName(null);
      setPatientNumber(null);
      setPatientEmail(null);
      setDepartment(null);
    } else if (filterParams && filterParams.name === "BY_DOCTOR") {
      setDoctorSearch(
        selectedDoctor && !filtersReset ? selectedDoctor?.doctorId : null
      );
      setAppointmentStatus(null);
      setPatientName(null);
      setAppointmentDateSearch(null);
      setPatientNumber(null);
      setPatientEmail(null);
      setDepartment(null);
      console.log("selectedDoctor", selectedDoctor?.doctorId);
    } else if (filterParams && filterParams.name === "BY_NUMBER") {
      setPatientNumber(filtersReset ? null : filterParams.value);
      setAppointmentStatus(null);
      setPatientName(null);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setPatientEmail(null);
      setDepartment(null);
    } else if (filterParams && filterParams.name === "BY_EMAIL") {
      setPatientEmail(filtersReset ? null : filterParams.value);
      setAppointmentStatus(null);
      setPatientName(null);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setPatientNumber(null);
      setDepartment(null);
    } else if (filterParams && filterParams.name === "BY_DEPARTMENT"){
      setDepartment(filtersReset ? null : filterParams.value);
      setAppointmentStatus(null);
      setPatientName(null);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setPatientNumber(null);
    }
    else if (filterParams && filterParams.name === "BY_SPECIALITY"){
      setSpecialityvalue(filtersReset ? null : filterParams.value);
      setAppointmentStatus(null);
      setPatientName(null);
      setDoctorSearch(null);
      setAppointmentDateSearch(null);
      setPatientNumber(null);
    }
  };
  console.log("filterReset", filtersReset);
  useEffect(() => {
    if (filterParams) {
      handleFilterAndSearch(filterParams);
    }
  }, [filterParams, doctorList]);

  //   useEffect(() => {
  //     if (filtersReset) {
  //         setFiltersReset(false);
  //     }
  // }, [filtersReset]);
 

  console.log("patientEmail", patientEmail);

  const formattedAppointmentDate = moment(appointmentDateSearch).format(
    "DD-MMM-YYYY"
  );
  const finalDate =
    appointmentDateSearch === null ? null : formattedAppointmentDate;

  console.log("doctorSearch", doctorSearch);

  useEffect(() => {
    let parm = {
      type: "C",
      operation: operation,
      operationDate: convertDateToString(new Date()),
      clinicId:
        JSON.parse(userData).userType === CLINIC_ADMIN
          ? JSON.parse(userData).clinicId
          : "",
      offset: 0,
      //selectedDate
      startDate: selectedDate.from,
      endDate: selectedDate.to,
      appointmentDate: appointmentDateSearch,
      appointmentStatus: appointmentStatus,
      patientName: patientName,
      patientNumber: formattedMobileNumber,
      patientEmail: patientEmail,
      doctorId: doctorSearch,
      department: department,
      speciality:specialityvalue
    };
    setLoader(true);
    setparamdata(parm);
    setActivePage(1);

    dispatch(
      FETCH_ADMIN_DASHBOARD_REPORT(
        parm,
        0,
        doctorSearch,
        finalDate,
        appointmentStatus,
        patientName,
        formattedMobileNumber,
        patientEmail,
        department,
        specialityvalue
      )
    ).then((res) => {
      console.log("FETCH_ADMIN_DASHBOARD_REPORT", res);
      setLoader(false);
      setDashboardData(res.data.appointmentlist);
      setDownloaable(res.data.appointmentlist.length > 0 ? true : false);
      setPagination(
        res.data.appointmentlist.length > 0 ? res.data.totalNumberOfPages : 0
      );
    });
  }, [
    userData,
    doctorSearch,
    finalDate,
    appointmentStatus,
    patientName,
    patientNumber,
    patientEmail,
    department,
    specialityvalue
  ]);

  let handleTableClick = (eachRow) => {
    dispatch({
      type: INTERBRANCH_ADMIN_DASHBOARD_SELECTED,
      payload: eachRow,
    });
    //dispatch(FETCH_DASHBOARD_MORE(eachRow.appointmentId));
    localStorage.setItem("apptid", eachRow.appointmentId);
    setModelOpen(true);

    // dispatch(setModalRedux({
    //     name: "todaysReportModal",
    //     value: true
    // }))
  };

  function refreshDataWithoutPageChange() {
    //This function is only for refresh data without pagination change. Eg: After accepting the request from modal
    localStorage.removeItem("apptid");
    // setLoader(true);
    //Passing active pagination from the state as "activePage"
    dispatch(
      FETCH_ADMIN_DASHBOARD_REPORT(paramdata, activePage - 1, doctorSearch)
    ).then((res) => {
      setDashboardData(res.data.appointmentlist);
      setLoader(false);
      updateSelectedData();
    });
  }

  function handleDrawerClose() {
    setModelOpen(false);
  }

  let handlePaginationChange = (e, s) => {
    // console.log(e,s);
    setLoader(true);
    setActivePage(e);
    dispatch(
      FETCH_ADMIN_DASHBOARD_REPORT(
        paramdata,
        e - 1,
        doctorSearch,
        finalDate,
        appointmentStatus,
        patientName,
        patientNumber,
        patientEmail,
        department,
        specialityvalue
      )
    ).then((res) => {
      setDashboardData(res.data.appointmentlist);
      setLoader(false);
    });
  };

  let handledoctorChange = (e, s) => {
    // console.log(e,s);
    setLoader(true);

    let parm = {
      type: "C",
      operation: operation,
      operationDate: convertDateToString(new Date()),
      clinicId:
        JSON.parse(userData).userType === CLINIC_ADMIN
          ? JSON.parse(userData).clinicId
          : "",
      offset: 0,
      //selectedDate
      startDate: selectedDate.from,
      endDate: selectedDate.to,
    };

    dispatch(FETCH_ADMIN_DASHBOARD_REPORT(parm, e - 1)).then((res) => {
      setDashboardData(res.data.appointmentlist);
      setLoader(false);
    });
  };
  const handleDateRangeChange = (fromDate, toDate) => {
    handledateChange([fromDate, toDate]);
    setSelectedRange([fromDate, toDate]);
    console.log("range", selectedRange);
    setDoctorSearch(null);
    setDepartment(null);
  };
  console.log("Date", selectedDate);

  let handledateChange = (e) => {
    if(filtersReset){
      setDepartment(null)
    }
    console.log("ehjgj", e);
    setSelectedRange(e);
    setOperation("find");
    if (e) {
      let [startDate, endDate] = e;
      setSelectedDate({
        from: convertDateToString(startDate),
        to: convertDateToString(endDate),
      });
      setLoader(true);
      let parm = {
        type: "C",
        operation: "find",
        startDate: convertDateToString(startDate),
        endDate: convertDateToString(endDate),
        clinicId:
          JSON.parse(userData).userType === CLINIC_ADMIN
            ? JSON.parse(userData).clinicId
            : "",
        offset: 0,
      };
      setparamdata(parm);
      dispatch(
        FETCH_ADMIN_DASHBOARD_REPORT(
          parm,
          0,
          doctorSearch,
          finalDate,
          appointmentStatus,
          patientName,
          patientNumber,
          patientEmail,
          department,
          specialityvalue
        )
      ).then((res) => {
        console.log(res);
        setDashboardData(res.data.appointmentlist);
        setPagination(res.data.totalNumberOfPages);
        setLoader(false);
      });

      // if (startDate < prevDate) {

      //     Modal.confirm({
      //         title: 'Confirm',
      //         // icon: <ExclamationCircleOutlined />,
      //         content: 'You can only view report within a 3 month span. Do you want to download the report before 3 months?',
      //         okText: 'Download Report',
      //         cancelText: 'cancel',
      //         onOk() {
      //            // downloadReport(startDate, endDate)
      //         },
      //     });
      // }
      // else {

      //     dispatch(FETCH_ADMIN_DETAILED_REPORT({fromDate:startDate,toDate:endDate}))
      //     //downloadReport(startDate, endDate)
      // }
    }
  };
  let filterOnClick = () => {
    setOpen(!isOpen);
  };

  const resetFilterAction = () => {
    setDepartment("");
    setAppointmentStatus(null);
    setPatientName(null);
    setAppointmentDateSearch(null);
    setPatientNumber(null);
    setPatientEmail(null);
    setDepartment(null);
    // setSelectedRange(null);
    setSelectedDoctorId(null);
    setresetfilter(true);
    setFilterParams(null);

    setOperation("start");
    let parm = {
      type: "C",
      operation: "start",
      operationDate: convertDateToString(new Date()),
      clinicId:
        JSON.parse(userData).userType === CLINIC_ADMIN
          ? JSON.parse(userData).clinicId
          : "",
      offset: 0,
    };
    setActivePage(1);
    setparamdata(parm);
    setLoader(true);
    if (filtersReset === false) {
      dispatch(FETCH_ADMIN_DASHBOARD_REPORT(parm, 0)).then((res) => {
        console.log(res);
        setLoader(false);
        setDashboardData(res.data.appointmentlist);
        setPagination(res.data.totalNumberOfPages);
      });
    }
  };

  console.log('deptments', department)

  const [isSearched, setIsSearched] = useState(false);

  // const handleSearchReset = () => {
  //   setIsSearched(false);
  //   // Call your resetFilterActionDate function here
  //   resetFilterActionDate();
  // };
  const resetFilterActionDate = () => {
    //setSelectedDoctorId(null)
    setresetfilter(true);
    setOperation("start");
    let parm = {
      type: "C",
      operation: "start",
      operationDate: convertDateToString(new Date()),
      clinicId:
        JSON.parse(userData).userType === CLINIC_ADMIN
          ? JSON.parse(userData).clinicId
          : "",
      offset: 0,
    };
    setActivePage(1);
    setparamdata(parm);
    setLoader(true);
    dispatch(FETCH_ADMIN_DASHBOARD_REPORT(parm, 0)).then((res) => {
      console.log(res);
      setLoader(false);
      setDashboardData(res.data.appointmentlist);
      setPagination(res.data.totalNumberOfPages);
    });
    setAppointmentDateSearch(null);
    setAppointmentStatus(null);
    setPatientName(null);
    setDoctorSearch(null);
    setDepartment(null);
    setIsSearched(false);
  };

  //This function is for update the drawer data if the table data change from drawer action like accept, reschedule appointment.
  const updateSelectedData = () => {
    let selectedDataUpdated = null;

    if (selectedAppointment && dashboardData?.length) {
      selectedDataUpdated = dashboardData.filter(
        (e) => e.appointmentId === selectedAppointment?.appointmentId
      )[0];
      console.log(
        "🚀 ~ file: TodaysReport.jsx:128 ~ refreshDataWithoutPageChange ~ selectedDataUpdated:",
        selectedDataUpdated
      );
    }

    dispatch({
      type: INTERBRANCH_ADMIN_DASHBOARD_SELECTED,
      payload: selectedDataUpdated || selectedAppointment,
    });
  };

  useEffect(() => {
    dispatch(fetch_doctors_list("Ganga Hospital", "")).then((res) => {
      console.log(res);
      setDoctorList(res);
      const names = res.map((doctor) => doctor.doctorName);
      setDoctorNames(names);

      console.log("doctorNames:", names);
    });
  }, [resetfilter]);

  return (
    <>
      <div className="appontment-history-container">
        <div className="header">
          {/* <button
            onClick={() => {
              downloadReport();
            }}
          >
            <div className="icon">
              <i class="far fa-download"></i>
            </div>{" "}
            Download Report
          </button>
          <div></div>
          <div className="d-flex flex-row align-items-right"></div>

          <div className="d-flex flex-row align-items-center">
            <div style={{ marginRight: "30px" }}>
              <Select
                className="custom-select"
                allowClear
                disabled={loader}
                placeholder="Select a doctor"
                style={{ width: 200 }}
                showSearch
                showArrow
                suffixIcon={
                  selectedDoctorId ? <CloseCircleOutlined /> : <DownOutlined />
                }
                onChange={(value) => {
                  console.log("Selected doctor", value);

                  const selectedDoctor = doctorList.find(
                    (doctor) => doctor.doctorName === value
                  );

                  if (selectedDoctor) {
                    setSelectedDoctorId(selectedDoctor.doctorId);
                    console.log('doctorId', selectedDoctor.doctorId)
                  } else {
                    setSelectedDoctorId(null);
                  }
                }}
              >
                {doctorNames?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="filter-button me-3">
              <div className="icon" onClick={filterOnClick}>
                <i class="far fa-calendar-alt"></i>
              </div>
              <RangePicker
                // open={isOpen}
                allowClear={false}
                ref={dateRef}
                bordered={false}
                className="date-picker"
                suffixIcon={null}
                format="DD-MMM-YYYY"
                value={selectedRange}
                // disabledDate={(current) => {
                //     return moment().add(-3, 'month') >= current
                //     // ||
                //     //  moment().add(1, 'month')  <= current;
                // }}
                onChange={handledateChange}
              />
            </div>
            */}
          {/* <ResetFilterButton
              visibility={selectedRange}
              handleReset={resetFilterAction}
            /> */}
          {/* </div>  */}
          <AdminAppointmentFilters
            onDownloadRequest={handleDownloadRequest}
            onFilterSubmit={(params) => {
              console.log("🚀 ~ TodaysReport ~ params:", params);
              setFilterParams(params);
            }}
            doctorNames={doctorNames}
            onDoctorSelect={handleDoctorSelect}
            onAppointmentDateChange={handleAppointmentDateChange}
            onAppointmentStatusChange={handleAppointmentStatusChange}
            onDateRangeChange={handleDateRangeChange}
            selectedRange={selectedRange}
            // setSelectedRange={setSelectedRange}
            resetFilterAction={resetFilterAction}
            setAppointmentDateSearch={setAppointmentDateSearch}
            appointmentDateSearch={appointmentDateSearch}
            isSearched={isSearched}
            setIsSearched={setIsSearched}
            resetFilterActionDate={resetFilterActionDate}
            setAppointmentStatus={setAppointmentStatus}
            appointmentStatus={appointmentStatus}
            doctorSearch={doctorSearch}
            selectedDoctor={selectedDoctor?.doctorName}
            downloaable={downloaable}
            patientNumber={patientNumber}
            patientEmail={patientEmail}
            isDownloadDisabled={dashboardData.length === 0}
            isDownloading={isDownloading}
            isLoading={loader}
            handledateChange={handledateChange}
            setFiltersReset={setFiltersReset}
            departments = {departments}
            setDepartment = {setDepartment}
            setDoctorSearch = {setDoctorSearch}
            speciality={ speciality}
          />
        </div>

        <div className="todays_report_table_container">
          {!loader ? (
            <table className="appoinment-table">
              <thead>
                <tr>
                  <th>Appointment ID</th>
                  <th>Appoinment Date & Time</th>

                  <th>Patient Name</th>
                  <th>Doctor Name</th>

                  <th>Fees Paid</th>
                  <th>Consultation Status</th>
                  {/* <th>Next Steps</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {dashboardData ? (
                  dashboardData.length > 0 ? (
                    dashboardData.map((eachRow, key) => {
                      if (key <= 10) {
                        return (
                          <tr>
                            <td>{eachRow.appointmentId}</td>
                            <td>
                              <div className="dashboard-appointment-date-time">
                                <span>{eachRow.appointmentdate} (P)</span>
                                <span>{eachRow.doctorappointmentdate} (D)</span>
                                {eachRow.isrescheduled != undefined &&
                                  eachRow.isrescheduled === "true" && (
                                    <span>
                                      <i>Rescheduled</i>
                                    </span>
                                  )}
                              </div>
                            </td>

                            <td>
                              <div className="dashboard-appointment-date-time">
                                <span>{eachRow.patientname}</span>
                                {eachRow.Appointmentfor === "Loved One" && (
                                  <span>Booked by: {eachRow.bookedby}</span>
                                )}
                                <span>{eachRow.timezone}</span>
                                <span>
                                  ({" "}
                                  {eachRow?.patientGender &&
                                    `${eachRow?.patientGender}, `}
                                  {(() => {
                                    const dob = eachRow?.patientDob;
                                    const dobDate = new Date(dob);
                                    const currentDate = new Date();
                                    const ageInMonths = Math.floor(
                                      (currentDate - dobDate) /
                                        (1000 * 60 * 60 * 24 * 30.4375)
                                    ); // Average number of days in a month
                                    const ageInYears = Math.floor(
                                      ageInMonths / 12
                                    );

                                    const formattedDob = dob?.replace(
                                      /-/g,
                                      "/"
                                    );

                                    if (ageInMonths < 1) {
                                      return `1 month`;
                                    } else if (ageInMonths < 12) {
                                      return `${ageInMonths} months`;
                                    } else {
                                      return `${ageInYears} years`;
                                    }
                                  })()}
                                  )
                                </span>
                              </div>
                            </td>

                            <td>
                               <div className="dashboard-appointment-date-time">
                                   <span>
                                    {eachRow.doctorname.startsWith("Dr.") 
                                      ? eachRow.doctorname 
                                      : `Dr. ${eachRow.doctorname}`}
                                  </span>

                                    <span>{eachRow.speciality}</span>
                                    <span>{eachRow.departmentName}</span>
                               </div>
                               </td>
                              
                            <td>
                              <div className="dashboard-appointment-date-time">
                                <span>{eachRow.fees}</span>
                                <span>{eachRow.paymentgatway}</span>
                              </div>
                            </td>
                            <td>{eachRow.appointmentStatus}</td>
                            {/* <td>{eachRow.appointmentStatus}</td> */}
                            {/* <td>{eachRow.followupdetails}</td> */}
                            <td>
                              <button
                                onClick={() => {
                                  handleTableClick(eachRow);
                                }}
                                className="more-btn"
                              >
                                More
                              </button>
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <EmptyTableData
                          isLoading={loader}
                          haveButton={false}
                          text={
                            isInitial &&
                            "LOOKS LIKE NO APPOINTMENT HAVE BEEN CREATED YET"
                          }
                          caption={""}
                        />
                      </td>
                    </tr>
                  )
                ) : null}
              </tbody>
            </table>
          ) : (
            <div
              className="loader"
              style={{ width: "100%", textAlign: "center" }}
            >
              <Spinner
                style={{
                  width: "4rem",
                  height: "4rem",
                  marginBottom: "15px",
                  color: "#01b2e6",
                }}
                animation="border"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div>Please Wait...</div>
            </div>
          )}
        </div>
        <div className="pagination-container-mis-report">
          &nbsp;
          <Pagination
            showSizeChanger={false}
            onChange={handlePaginationChange}
            current={activePage}
            total={pagination * 10}
            hideOnSinglePage={true}
          />
        </div>
      </div>
      <Drawer
        className="appointmentDetailsDrawer"
        closeIcon={false}
        title={false}
        key={isModelOpen ? "1" : "2"}
        placement="right"
        onClose={handleDrawerClose}
        open={isModelOpen}
      >
        <TodaysReportModalContent
          handleTableRefresh={refreshDataWithoutPageChange}
        />
      </Drawer>
    </>
  );
}

export default TodaysReport;
